import { render } from "./create_api.vue?vue&type=template&id=275b66c2&scoped=true"
import script from "./create_api.vue?vue&type=script&lang=js"
export * from "./create_api.vue?vue&type=script&lang=js"

import "./create_api.vue?vue&type=style&index=0&id=275b66c2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275b66c2"]])

export default __exports__